const InfoIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="7" stroke="#e3a008" strokeWidth="1.2" />
    <path d="M8 5V5.01" stroke="#e3a008" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M8 7V11" stroke="#e3a008" strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);

export default InfoIcon;
